
<div :class="jel_getClassObject(content)">
  <div class="container p-0">
    <div class="limit-frame">
      <div class="text-left">
        <!-- Aucune erreur système (cas normal)  -->
        <div class="period-buttons">
          <a
            v-for="key in tabs"
            :key="key"
            :href="`#${key}`"
            class="btn"
            :class="{ active: activeTab === key }"
            @click="activeCategory(key, $event)"
          >
            <svg-icon
              aria-label="share"
              class="svg-icon-share stat-item-icon"
              :icon-name="getIconName(key)"
            ></svg-icon>
            {{ $t(`compte.limite.${key}`) }}
          </a>
        </div>
        <div
          id="spinner"
          :class="{
            'd-flex flex-column justify-content-center align-items-center text-center':
              isSpinnerVisible,
            'd-none': !isSpinnerVisible,
          }"
        >
          <b-spinner :label="$t('chargement')"></b-spinner>
        </div>

        <div v-show="!isSpinnerVisible">
          <!-- Affichage des erreurs systèmes -->
          <div v-if="isErreurServeur[activeTab]">
            <MessageMel
              v-show="contentMessageMel.message"
              :content="contentMessageMel.message"
              class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
            ></MessageMel>
          </div>

          <div v-else-if="limits[activeTab]">
            <div class="info-category">
              <Paragraphe
                :content="{
                  richText: getContentDescription(activeTab),
                  classeCSS: 'text-left',
                }"
                class="texte-desc"
              ></Paragraphe>
              <div class="lien-aide">
                <Hyperlien
                  class="ico-lien-aide rounded-circle cercleInfo"
                  :content="contentLienAideLimitesJeux(activeTab)"
                ></Hyperlien>
              </div>
            </div>
            <LimitSection
              :key="activeTab"
              :category="activeTab"
              :limitValues="limits[activeTab]"
              :content="content"
            />
          </div>
        </div>
        <Paragraphe
          v-if="activeTab === 'time'"
          :content="{
            richText: content.textLegal,
            classeCSS: 'px-2 py-2',
          }"
          class="texte-desc"
        ></Paragraphe>
        <div class="item-frame">
          <svg-icon
            aria-label="share"
            class="svg-icon-share stat-item-icon"
            icon-name="ic-limit-frame"
          ></svg-icon>
          <Paragraphe
            :content="{
              richText: content.txtInfoExterne,
              classeCSS: 'px-2',
            }"
            class="texte-item-frame"
          ></Paragraphe>
        </div>
      </div>
    </div>
  </div>
</div>
